import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary, warning } = theme.palette;

  return {
    FOTButton: {
      width: 129,
      height: 24,
      color: primary.dark,
      display: "flex",
      alignItems: "center",
      border: `${primary.light} 1px solid`,
      borderRadius: 3,
      fontSize: 12,
      padding: 6
    },
    FOTButton__activeFOT: {
      backgroundColor: warning.main,
      color: "#ffffff",
      border: `${warning.accent} 1px solid`,
      "&:hover": {
        backgroundColor: warning.accent
      }
    },
    examReasonNote: {
      paddingLeft: 20,
      marginBottom: 16,
      [theme.breakpoints.down(Breakpoints.MD_960)]: {
        width: "calc(100vw - 232px)"
      },
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        display: "flex",
        flexDirection: "column",
        width: "calc(100vw - 150px)"
      }
    },
    link: {
      fontSize: 13,
      textDecoration: "underline",
      cursor: "pointer"
    },
    linkReadOnly: {
      textDecoration: "none",
      cursor: "default"
    },
    date: {
      fontSize: 12
    },
    dateDash: {
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        display: "none"
      }
    },
    body: {
      fontSize: 12,
      padding: 0,
      margin: 0,
      wordBreak: "break-word"
    },
    dialogPaper: {
      width: 296,
      minHeight: 359
    },
    dialogTitle: {
      padding: "11px 20px",
      "& .MuiTypography-h6": {
        fontWeight: 700
      }
    },
    dialogContent: {
      display: "flex",
      flexDirection: "column",
      padding: "0 16px 16px 16px"
    },
    dialogActions: {
      display: "flex",
      gap: 4,
      justifyContent: "end",
      padding: "12px 16px",
      "& > div": {
        flex: 1,
        display: "flex",
        gap: 4,
        justifyContent: "end"
      }
    },
    dialogActionsAlt: {
      "& > div": {
        justifyContent: "space-between"
      }
    },
    dialogCloseButton: {
      position: "absolute",
      top: 8,
      right: 8
    },
    dialogCloseButtonIcon: {
      fontSize: 28
    },
    horseName: {
      padding: 0,
      fontWeight: 700,
      marginBottom: 8,
      wordBreak: "break-word"
    },
    trainerName: {
      padding: 0,
      marginBottom: 16,
      wordBreak: "break-word"
    },
    flagCommentHeader: {
      padding: 0,
      marginBottom: 10,
      wordBreak: "break-word",
      display: "flex",
      justifyContent: "space-between"
    },
    flagComment: {
      marginTop: 0
    },
    textarea: {
      wordBreak: "break-word",
      "& label.MuiFormLabel-root": {
        color: secondary.dark
      },
      "& label.MuiFormLabel-root.Mui-focused": {
        color: secondary.dark
      },
      "&:hover label.MuiFormLabel-root": {
        color: secondary.dark
      },
      "& .MuiOutlinedInput-root fieldset": {
        borderColor: secondary.dark
      }
    },
    textareaLabel: {
      color: primary.light
    },
    buttonDelete: {
      color: warning.dark,
      fontWeight: 700,
      fontSize: 16
    },
    buttonCancel: {
      color: primary.dark,
      fontWeight: 700,
      fontSize: 16
    },
    buttonSave: {
      color: secondary.dark,
      fontWeight: 700,
      fontSize: 16
    },
    activeFlaggedIcon: {
      color: "inherit",
      marginRight: 4,
      fontSize: 12,
      position: "relative"
    },
    authorDate: {
      fontSize: 11,
      margin: 0,
      padding: 0
    },
    noteEditButton: {
      padding: 0,
      color: secondary.dark
    },
    noteEditIcon: {
      fontSize: 18
    }
  };
});
